import React from 'react';
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'

const Alerts = () => {

    return (
        <>
            <Header />
            <MobileNav />
            <div className='py-[80px] px-5 max-w-[1100px] mx-auto'>
                <h1 className='text-2xl font-semibold mb-2 md:mt-8'>Alerts</h1>
                <p className='mt-10'>
                    This feature is coming soon. Stay tuned for getting notified when your spot turns on.
                </p>
            </div>
        </>
    )
}

export default Alerts
